module.exports = __webpack_public_path__ + "static/media/61.8004a2c6.jpg";